import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyle = makeStyles(theme => ({
  imgStyle: {
    width: 100,
    userDrag: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      width: 100,
    },

    [theme.breakpoints.down('sm')]: {
      display: 'block',
      width: 70,
    },
  },
  hidden: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      width: 100,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      width: 70,
    },
  },
}));

export const ResponsiveLogo = ({ src, alt }) => {
  const classes = useStyle();
  const [showLogo, setShowLogo] = useState(false);
  const setLogoSize = () => {
    if (window.scrollY <= 150) {
      setShowLogo(false);
    } else {
      setShowLogo(true);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', setLogoSize);
  });
  return (
    <img
      src={src}
      alt={alt}
      className={showLogo ? classes.imgStyle : classes.hidden}
    />
  );
};
ResponsiveLogo.defaultProps = {
  alt: '#',
};

ResponsiveLogo.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
};
